<template>
  <div
  class="product-item ajax_block_product"
  :class="{'not_avaiable_product' : post.isAvailable === '0' || post.isAvailable === 0 || post.isAvailable === false}">
    <div class="pro_first_box">
      <a class="product_img_link" :href="post.url" :title="removeDash(post.brand) + ' ' + post.product_name">
        <picture class="front-image">
          <img class="lazyload" :src="prestaUrl + '/public/assets/FFF.png'" :data-src="post.photoUrl" :alt="removeDash(post.brand) + ' ' + post.product_name" />
        </picture>
        <div class="c-product-box__labels">
          <div v-for="label in post.labels" :key="label">
            <span class="c-product-label c-product-label--onsale" v-if="label === 'sale'">Sale</span>
            <span class="c-product-label" v-if="label === 'new'">Nowość</span>
          </div>
          <span
              class="c-product-label c-product-label--down"  v-if="post.promoPrc > 0"
            >PROMO</span>
        </div>
      </a>
      <div class="hover_fly fly_2 clearfix">
        <button
          v-if="post.isAvailable === '1' || post.isAvailable === 1 || post.isAvailable === true"
          :data-href="prestaUrl + 'cart?add=1&id_product='+ objectId(post.objectID) +'&token=4d8443d23893863f78733d555b70e5cb'"
          class="c-btn c-btn--default c-btn--theme-6 u-text-uppercase ajax_add_to_cart_button"
          :data-product-id="'ajax_id_product_' + objectId(post.objectID)"
          :data-product-id-attribute="objectCombination(post.objectID)"
        >
          <span class="c-btn__wrap">
            <span class="c-btn__ico">
              <span class="o-ico o-ico--basket o-ico--m has-animate">
                <svg aria-hidden="true">
                  <use xlink:href="#ico-new-basket-anim" />
                </svg>
              </span>
            </span>
            <span class="c-btn__label">Do koszyka</span>
          </span>
        </button>
        <a
          v-if="post.isAvailable === '0' || post.isAvailable === 0 || post.isAvailable === false"
          @click="notificationOpen"
          :class="'c-btn c-btn--default c-btn-notification js-notification-open-list' + objectId(post.objectID)"
        >
          <span class="c-btn__wrap">
            <span class="c-btn__ico c-btn__notify">
              <span class="o-ico o-ico--bell o-ico--s">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="far"
                  data-icon="bell"
                  class="svg-inline--fa fa-bell fa-w-14"
                  role="img"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
                  />
                </svg>
              </span>
            </span>
            <span class="c-btn__label">Powiadom</span>
          </span>
        </a>
        <input type="hidden" class="js-productlist-notification-data" :data-id="objectId(post.objectID)"/>
        <a
          @click="addFavourite"
          rel="nofollow"
          :title="titleButton"
          aria-label="Dodaj do listy życzeń"
          aria-hidden="true"
          class="wish-btn c-btn c-btn--ico"
          :class="{ 'is-active': favActive }"
          :data-wish-options="'{ &quot;id&quot;: &quot;wishlist_block_list&quot;, &quot;action&quot;: &quot;add&quot;, &quot;idProduct&quot;: '+ objectId(post.objectID) +', &quot;idProductAttribute&quot;: &quot;&quot;, &quot;quantity&quot;: 1 }'"
        >
          <span class="c-btn__ico">
            <span class="o-ico o-ico--heart o-ico--s has-animate" v-if="!favActive">
              <svg aria-hidden="true">
                <use xlink:href="#ico-heart-bordered-anim" />
              </svg>
            </span>
            <svg
              class="o-ico o-ico--heart o-ico--s has-animate is-animating"
              viewBox="0 0 62 56"
              v-if="favActive"
            >
              <g class="sparkle-group">
                <circle cx="2" cy="19" r="2" />
                <circle cx="17" cy="7" r="2" />
                <circle cx="32" cy="2" r="2" />
                <circle cx="47" cy="7" r="2" />
                <circle cx="60" cy="19" r="2" />
              </g>

              <path
                class="filled"
                d="M31.4,54.2c-0.5,0-0.9-0.2-1.2-0.5L15.5,38.9c-3.7-3.8-3.7-9.9,0-13.6c1.8-1.8,4.3-2.8,6.8-2.8s5,1,6.8,2.8l2.3,2.3
        l2.3-2.3c1.8-1.8,4.2-2.8,6.8-2.8c2.5,0,5,1,6.8,2.8c3.7,3.7,3.7,9.8,0.1,13.6c0,0-14.7,14.8-14.7,14.8
        C32.3,54,31.9,54.2,31.4,54.2z"
              />
              <path
                d="M40.5,24.2c2.1,0,4.1,0.8,5.5,2.3c3.1,3.1,3.1,8.1,0,11.2l0,0L31.4,52.4L16.8,37.7c-3.1-3.1-3.1-8.1,0-11.2
        c1.5-1.5,3.5-2.3,5.5-2.3c2.1,0,4.1,0.8,5.5,2.3l2.3,2.3c0.3,0.3,0.8,0.5,1.2,0.5c0.4,0,0.9-0.2,1.2-0.5l2.3-2.3
        C36.4,25,38.4,24.2,40.5,24.2 M40.5,20.7c-3,0-5.9,1.2-8,3.4l-1,1.1l-1-1.1c-2.1-2.1-5-3.3-8-3.3c-3,0-5.9,1.2-8,3.4
        c-4.4,4.4-4.4,11.7,0,16.1l14.6,14.7c0.7,0.7,1.6,1,2.5,1s1.8-0.4,2.5-1l14.6-14.7c0,0,0.1-0.1,0.1-0.1c4.3-4.4,4.3-11.6-0.1-16
        C46.4,21.9,43.5,20.7,40.5,20.7L40.5,20.7z"
              />
            </svg>
          </span>
          <span class="c-btn__label">Do ulubionych</span>
          <span class="c-btn__label is-active-label">Ulubiony</span>
        </a>
        <div class="js-productlist-notification" :data-id="objectId(post.objectID)"></div>
        <ProductListNotification
          v-if="post.isAvailable === '0' || post.isAvailable === 0 || post.isAvailable === false"
          :urlImage="post.photoUrl"
          :idProduct="objectId(post.objectID)"
          :urlProduct="prestaUrl +'module/mailalerts/actions?process=add'"
          ref="foo"
        ></ProductListNotification>
      </div>
    </div>
    <div class="pro_second_box">
      <a
        class="js-product-name"
        :href="post.url"
        :title="removeDash(post.brand) + ' ' + post.product_name"
      >
        <p class="s_title_block nohidden">
            <span class="brandname">{{ removeDash(post.brand) }}</span>
            <span class="productname">{{ post.product_name }}</span>
        </p>
        <div class="product-item__rating">
          <div class="js-dbs-products-reviews--product-list-product" :data-productId="objectId(post.objectID)"></div>
        </div>
        <div
          :class="[{ 'price-with-promotion price_container': promo }, { 'price-without-promotion price_container': !promo }]"
        >
          <span class="price js-product-price price-orange" v-if="post.priceNewTI || post.priceOldTI">{{ roundNumber(post.priceNewTI) }} zł</span>
          <span class="old_price price-gray" v-if="post.priceNewTI < post.priceOldTI">{{ roundNumber(post.priceOldTI) }} zł</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { addWish, removeWish } from '@/api/wishList'
import ProductListNotification from '@/components/ProductListNotification/ProductListNotification.vue'
export default {
  name: 'SearchProductItem',
  components: {
    ProductListNotification
  },
  data: function () {
    return {
      // eslint-disable-next-line no-undef
      prestaUrl: baseUri,
      favActive: false,
      titleButton: 'Dodaj do ulubionych',
      promo: false
    }
  },
  props: {
    post: Object,
    index: Number
  },
  created () {
    let favList = JSON.parse(localStorage.favouriteList)
    if (Array.isArray(favList)) {
      favList.forEach(item => {
        if (item.id_product === this.objectId(this.post.objectID)) {
          this.favActive = true
          this.titleButton = 'Usuń z ulubionych'
        }
      })
    }
    if (this.post.priceNewTI < this.post.priceOldTI) {
      this.promo = true
    }
    let menu = document.querySelectorAll('.show_if_vue .categories_tree_block > ul ul')
    let grower = document.querySelectorAll('.show_if_vue .categories_tree_block > ul .grower')
    if (window.screen.width < 768) {
      setTimeout(() => {
        menu.forEach(menuList => {
          menuList.style.display = 'none'
        })
        grower.forEach(growerItem => {
          growerItem.classList.remove('OPEN')
          growerItem.classList.add('CLOSE')
        })
      }, 500)
    }
  },
  methods: {
    objectId (id) {
      let idSplit = id.split('-')
      return idSplit[0]
    },
    objectCombination (id) {
      let idSplit = id.split('-')
      return idSplit[1]
    },
    removeDash: function (value) {
      if (!value) return ''
      value = value.split('_').join(' ')
      return value
    },
    roundNumber: function (number) {
      return number.toFixed(2).replace('.', ',')
    },
    appendIco () {
      return `<svg class="o-ico o-ico--heart o-ico--s has-animate" viewBox="0 0 62 56">
    <g class="sparkle-group">
        <circle cx="2" cy="19" r="2"></circle>
        <circle cx="17" cy="7" r="2"></circle>
        <circle cx="32" cy="2" r="2"></circle>
        <circle cx="47" cy="7" r="2"></circle>
        <circle cx="60" cy="19" r="2"></circle>
    </g>

    <path class="filled" d="M31.4,54.2c-0.5,0-0.9-0.2-1.2-0.5L15.5,38.9c-3.7-3.8-3.7-9.9,0-13.6c1.8-1.8,4.3-2.8,6.8-2.8s5,1,6.8,2.8l2.3,2.3
        l2.3-2.3c1.8-1.8,4.2-2.8,6.8-2.8c2.5,0,5,1,6.8,2.8c3.7,3.7,3.7,9.8,0.1,13.6c0,0-14.7,14.8-14.7,14.8
        C32.3,54,31.9,54.2,31.4,54.2z"/>
    <path d="M40.5,24.2c2.1,0,4.1,0.8,5.5,2.3c3.1,3.1,3.1,8.1,0,11.2l0,0L31.4,52.4L16.8,37.7c-3.1-3.1-3.1-8.1,0-11.2
        c1.5-1.5,3.5-2.3,5.5-2.3c2.1,0,4.1,0.8,5.5,2.3l2.3,2.3c0.3,0.3,0.8,0.5,1.2,0.5c0.4,0,0.9-0.2,1.2-0.5l2.3-2.3
        C36.4,25,38.4,24.2,40.5,24.2 M40.5,20.7c-3,0-5.9,1.2-8,3.4l-1,1.1l-1-1.1c-2.1-2.1-5-3.3-8-3.3c-3,0-5.9,1.2-8,3.4
        c-4.4,4.4-4.4,11.7,0,16.1l14.6,14.7c0.7,0.7,1.6,1,2.5,1s1.8-0.4,2.5-1l14.6-14.7c0,0,0.1-0.1,0.1-0.1c4.3-4.4,4.3-11.6-0.1-16
        C46.4,21.9,43.5,20.7,40.5,20.7L40.5,20.7z"/>
  </svg>`
    },
    addFavourite () {
      if (window.trinyConfig.customer.logged) {
        let vm = this
        // eslint-disable-next-line no-inner-declarations
        function toggleLike (target, item) {
          const dataOptions = {
            id: 'wishlist_block_list',
            action: 'add',
            idProduct: vm.objectId(vm.post.objectID),
            idProductAttribute: '',
            quantity: 1
          }
          // const icoSelector = item.querySelector('svg')
          const idCombinationSelector = document.querySelectorAll(
            '#idCombination'
          )
          const quantityWantedSelector = document.querySelectorAll(
            '#quantity_wanted'
          )

          if (idCombinationSelector.length) {
            dataOptions.idProductAttribute = idCombinationSelector[0].value
          }

          if (quantityWantedSelector.length) {
            dataOptions.quantity = quantityWantedSelector[0].value
          }
          item = vm.$el.querySelector('.wish-btn')
          if (!item.classList.contains('is-active')) {
            item.querySelector('.c-btn__ico').innerHTML = vm.appendIco()
            let icoSelector = item.querySelector('svg')
            item.classList.add('is-active')
            item.title = 'Usuń z ulubionych'
            icoSelector.classList.add('is-animating')
            addWish(dataOptions)
              .then(data => {
                if (data !== undefined) {
                }
              })
              .catch(function () {
                let icoSelector = item.querySelector('svg')
                item.classList.remove('is-active')
                icoSelector.classList.remove('is-animating')
                // eslint-disable-next-line no-undef
                art
                  .dialog({
                    id: 'add_to_cart_dialog',
                    fixed: true,
                    opacity: 0.5,
                    lock: true
                  })
                  .content("Brak internetu :( Spróbuj gdy się połączysz."); // eslint-disable-line
              })
          } else {
            let icoSelector = item.querySelector('svg')
            item.classList.remove('is-active')
            item.title = 'Dodaj do ulubionych'
            icoSelector.classList.remove('is-animating')
            removeWish(dataOptions)
              .then(data => {
                if (data !== undefined) {
                }
              })
              .catch(function () {
                let icoSelector = item.querySelector('svg')
                item.classList.add('is-active')
                icoSelector.classList.add('is-animating')
                // eslint-disable-next-line no-undef
                art
                  .dialog({
                    id: 'add_to_cart_dialog',
                    fixed: true,
                    opacity: 0.5,
                    lock: true
                  })
                  .content("Brak internetu :( Spróbuj gdy się połączysz."); // eslint-disable-line
              })
          }
        }

        // eslint-disable-next-line no-inner-declarations
        toggleLike(event.target, this)
      } else {
        let popup = document.querySelector('.js-open-log-in')
        // modules/hifacebookconnect/views/js/facebook-connect-front.js
        var script = document.createElement('script')
        script.src = '/modules/hifacebookconnect/views/js/facebook-connect-front.js'
        script.type = 'text/javascript'
        document.body.parentNode.appendChild(script)
        const eventClick = new Event('click')
        popup.dispatchEvent(eventClick)
      }
    },
    notificationOpen () {
      this.$refs.foo.modalOpen()
    }
  }
}
</script>
<style lang="scss" scoped>
.product-item {
  //   text-decoration: none;
  //   display: block;
  //   color: #444;
  //   text-align: center;
  &.active {
    display: block;
  }
  //   &:hover {
  //     box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  //     position: relative;
  //     z-index: 2;
  //     .product-item__desc {
  //       background: #fafafa;
  //     }
  //     .product-item__btn {
  //       opacity: 1;
  //     }
  //   }
  &__desc {
    padding: 6px;
    position: relative;
  }
  &__discount {
    position: absolute;
    top: 0;
    left: 0;
    background: #f0825c;
    display: block;
    height: 25px;
    padding: 8px 5px 0;
    font-size: 11px;
    text-transform: uppercase;
    text-align: center;
    line-height: 1;
    color: #fff;
    box-sizing: border-box;
  }
  &__img {
    min-height: 265px;
    margin: 0;
    @media all and (max-width: 992px) {
      min-height: 0;
    }
    img {
      max-width: 100%;
    }
  }
  &__btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100%;
    background: #6ed2b5;
    color: #fff;
    height: 39px;
    line-height: 39px;
    white-space: nowrap;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
    opacity: 0;
    svg {
      width: 29px;
      height: 27px;
      margin: -11px 5px 0 0;
      display: inline-block;
      vertical-align: middle;
    }
    &:hover {
      background-color: #8ab82d !important;
    }
  }
  &__manufacturer {
    color: #bebebd;
    clear: both;
    display: block;
    margin: 0 15px;
    font-size: 12px;
  }
  &__title {
    min-height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: normal;
    font-size: 13px;
    margin: 0 15px;
  }
  &__price {
    text-align: center;
    margin-bottom: 6px;
    font-size: 13px;
    .price-new {
      color: #8ab82d;
      font-size: 1.333em;
      font-weight: bold;
      margin-right: 4px;
    }
    .price-old {
      text-decoration: line-through;
      color: #999;
      font-size: 12px;
      white-space: nowrap;
    }
  }
  &__rating {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .dbs_pr-product-list__ratings_count {
      padding: 0 0 3px 5px;
      font-size: 10px;
      color: #333;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Algolia/components/search-products-item.vue